const config = require('../../config');
const helper =  require('./helper');

exports.markReadActivity = markReadActivity;
exports.getNextNotificationsFromCache = getNextNotificationsFromCache;
exports.setGlobalsForApiCalls = setGlobalsForApiCalls;
exports.getServiceAnnoucement = getServiceAnnoucement;
exports.getLaunchType = getLaunchType;

let globals = {
    apiGatewayUrl: '/notifications/apigateway/',
    cursorOffset: 0, // value : 0,5,10,15
    apiOffset: 0, // value : 0,25,50
    cacheIndex: {
        totalNotificationLeft: 0
    },
    notificationJsonCache: {}
}

async function markReadActivity(activity) {
    try {
        const request = {
            method: 'GET',
            url: `${globals.apiGatewayUrl}user/notifications/activity/${activity.groupActivityId}/mark_read`,
            headers: {
                "Content-Type": "application/json"
            }
        }
        let markReadResponse = await helper.makeRequest(request);
        markReadResponse = JSON.parse(markReadResponse);
        return markReadResponse;
    } catch (error) {
        console.error('Augh, there was an error!', error.statusText);
        console.log(error);
    }
}

function setGlobalsForApiCalls(data) {
    if (data.apiGatewayUrl) globals.apiGatewayUrl = data.apiGatewayUrl;
}

function getLaunchType() {
    return globals.launchType;
}

async function getNotificationsOfUser() {
    try {
        const request = {
            method: 'POST',
            url: `${globals.apiGatewayUrl}user/notifications`,
            params: {},
            headers: {
                "Content-Type": "application/json"
            }
        }
        if (globals.apiOffset) {
            request.params.offset = globals.apiOffset;
        }
        let response = await helper.makeRequest(request);
        response = JSON.parse(response);
        let notification = response.feedData;
        config["ieltsBundleCode"] = response.metaData?.ieltsBundleCode;
        globals.apiOffset = globals.apiOffset + config.numberOfNotificationFromApi;
        globals.launchType = response.launchType;
        return notification;
    } catch (error) {
        console.error('Augh, there was an error!', error.statusText);
        console.log(error);
    }
}

async function getServiceAnnoucement(){
    try {
        let annoucementJsonCache = JSON.parse(sessionStorage.getItem(config.appSetting.sessionStorage.announcement.key));
        if(annoucementJsonCache && ( (annoucementJsonCache['fetchTime'] + config.appSetting.sessionStorage.announcement.cachingTime) > Date.now())){
            return annoucementJsonCache;
        }
        const request = {
            method: 'POST',
            url: `${globals.apiGatewayUrl}global/annoucements`,
            params: {},
            headers: {
                "Content-Type": "application/json"
            }
        }

        let response = await helper.makeRequest(request);
        response = JSON.parse(response);
        response['fetchTime'] = Date.now();
        sessionStorage.setItem(config.appSetting.sessionStorage.announcement.key, JSON.stringify(response) );
        return response ;
    } catch (error) {
        console.error('Augh, there was an error!', error.statusText);
        console.log(error);
    }
}
async function getNextNotificationsFromCache(isGlobalsReset) {
    // when notification class is reinitialised then reset cache to default
    if (isGlobalsReset) {
        globals = {
            apiGatewayUrl: globals.apiGatewayUrl,
            cursorOffset: 0, // value : 0,5,10,15
            apiOffset: 0, // value : 0,25,50
            cacheIndex: {
                totalNotificationLeft: 0
            },
            notificationJsonCache: {}
        }
    }
    let cache = globals.notificationJsonCache;
    if (!(cache.results && cache.results.length > 0)) {
        cache = await getNotificationsOfUser();
    }
    const notificationToReturn = {...cache,
        results: cache.results.slice(0, config.numberOfNotificationEachTimeRendered)
    }
    notificationToReturn.cursorOffset = globals.cursorOffset;
    globals.cursorOffset = globals.cursorOffset + config.numberOfNotificationEachTimeRendered;
    // update cache
    cache.results = cache.results.slice(config.numberOfNotificationEachTimeRendered);
    if (cache.next || cache.results.length > 0)
        notificationToReturn.next = true;
    globals.notificationJsonCache = cache;
    return notificationToReturn;
}

